import React, { useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';
import { cardMarkup } from './gameHelpers';
import CardDeck from './CardDeck';

// Rendered only for the judge. Until everyone has played, it shows a waiting
// state; once all cards are in, the judge cycles the submissions and picks one.
const Judging = ({ blackCard, allPlayed, submissions = [], waitingOn = 0 }) => {
  const { game, pickWinner } = useContext(GlobalContext);

  if (!allPlayed) {
    return (
      <div id="tm__judging" className="tm2">
        <h3>You're the judge!</h3>
        {blackCard && (
          <div
            className="blackcard--preview cardstack__black"
            dangerouslySetInnerHTML={cardMarkup(blackCard)}
          />
        )}
        <h3>
          <i className="fas fa-circle-notch fa-spin"></i> Waiting for {waitingOn}{' '}
          player{waitingOn === 1 ? '' : 's'} to play…
        </h3>
        {game?.error && (
          <p className="error" role="alert">
            {game.error}
          </p>
        )}
      </div>
    );
  }

  return (
    <div id="tm__judging" className="tm2">
      <h3>Pick the winning card</h3>
      {blackCard && (
        <div
          className="blackcard--preview cardstack__black"
          dangerouslySetInnerHTML={cardMarkup(blackCard)}
        />
      )}

      <CardDeck
        items={submissions}
        getText={(submission) => submission.card}
        onCommit={(submission) => pickWinner(submission.playerId)}
        commitLabel="Pick Winner"
        committingLabel="Picking…"
        countLabel={(n, total) => `Submission ${n} of ${total}`}
      />

      {game?.error && (
        <p className="error" role="alert">
          {game.error}
        </p>
      )}
    </div>
  );
};

export default Judging;
